export default __webpack_public_path__ + "static/media/C0004.47dd9a65.png";